<!--
 * @Author: DQL
 * @Date: 2022-04-28 11:18:16
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 17:07:20
 * @Description: 维保计划管理
-->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        维保计划管理
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        />
        <k-button
          btn-text="新增"
          :auth-type="true"
          type="success"
          icon="kestrel-icon ki-plus"
          @click="handleDialog('addPatch', {dlType: 'add'})"
        />
        <k-button
          btn-text="批量添加月计划（按本年月份）"
          :auth-type="true"
          type="primary"
          icon="kestrel-icon ki-plus"
          plain
          @click="handleDialog('bnyf', {dlType: 'bnyf'})"
        />
        <k-button
          btn-text="批量添加月计划（按合同周期）"
          :auth-type="true"
          type="primary"
          icon="kestrel-icon ki-plus"
          plain
          @click="handleDialog('htzq', {dlType: 'htzq'})"
        />
        <k-button
          btn-text="导出"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-export"
          plain
          :disabled="page.rows.length<1"
          @click="handleExport()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div
      class="l-page__item l-page--search__item"
    >
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :rules="filterParamsRules"
          :inline="true"
          label-position="right"
          label-width="110px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="合同有效期"
                prop="htyxQz"
              >
                <hm-date-range
                  ref="dateRange"
                  v-model="filterParams.htyxQz"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                prop="xmmc"
              >
                <el-input
                  v-model.trim="filterParams.xmmc"
                  class="c-form__input"
                  placeholder="请输入项目名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane
          label="查询结果"
        >
          <!-- table的ref的命名根据业务名称修改 -->
          <k-table
            ref="kTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template
              #xmmc="scope"
            >
              <el-link
                type="primary"
                @click="openNavTab({ name: 'wbjhList', params: { xmId: scope.row.xmId } })"
              >
                {{ scope.row.xmmc }}
              </el-link>
            </template>

            <template
              #htrq="scope"
            >
              {{ scope.row.htyxqQ | date('yyyy-MM-dd') }}
              至
              {{ scope.row.htyxqZ | date('yyyy-MM-dd') }}
            </template>
            <template
              #jhzs="scope"
            >
              <el-link
                type="primary"
                @click="openNavTab({ name: 'wbjhList', params: { xmId: scope.row.xmId} })"
              >
                {{ scope.row.jhzs }}
              </el-link>
            </template>
            <template
              #wkss="scope"
            >
              <el-link
                type="primary"
                @click="openNavTab({ name: 'wbjhList', params: { xmId: scope.row.xmId ,jhzt:'WKS'} })"
              >
                {{ scope.row.wkss }}
              </el-link>
            </template>
            <template
              #zxz="scope"
            >
              <el-link
                type="primary"
                @click="openNavTab({ name: 'wbjhList', params: { xmId: scope.row.xmId ,jhzt:'ZXZ'} })"
              >
                {{ scope.row.zxz }}
              </el-link>
            </template>
            <template
              #dscbg="scope"
            >
              <el-link
                type="primary"
                @click="openNavTab({ name: 'wbjhList', params: { xmId: scope.row.xmId ,jhzt:'DSC'} })"
              >
                {{ scope.row.dscbg }}
              </el-link>
            </template>
            <template
              #ywc="scope"
            >
              <el-link
                type="primary"
                @click="openNavTab({ name: 'wbjhList', params: { xmId: scope.row.xmId ,jhzt:'DGZ'} })"
              >
                {{ scope.row.ywc }}
              </el-link>
            </template>
            <template
              #ygdzz="scope"
            >
              <el-link
                type="primary"
                @click="openNavTab({ name: 'wbjhList', params: { xmId: scope.row.xmId ,jhzt:'YGZ'} })"
              >
                {{ scope.row.ygdzz }}
              </el-link>
            </template>
            <template
              #wcbfb="scope"
            >
              <el-link
                type="primary"
                @click="openNavTab({ name: 'wbjhList', params: { xmId: scope.row.xmId } })"
              >
                {{ scope.row.wcbfb }}
              </el-link>
            </template>
          </k-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 页面主内容：查询列表 End -->
    <!-- 新增/修改维保计划信息 -->
    <wbjh-update-dialog
      v-if="showDialogName==='add'"
      :dl-params="dialogParams"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />

    <wbjh-save-dialog
      v-if="showDialogName==='addPatch'"
      :dl-params="dialogParams"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />

    <!-- 批量新增维保计划信息 -->
    <wbjh-batch-update-dialog
      v-if="showDialogName==='bnyf' || showDialogName==='htzq'"
      :dl-params="dialogParams"
      @callback="refreshSearch()"
      @closeDialog="handleDialog"
    />
  </div>
</template>

<script>
import { wbjhService } from './wbjh.service';
import WbjhUpdateDialog from './updateDialog.vue';
import WbjhBatchUpdateDialog from './batchUpdateDialog.vue';
import WbjhSaveDialog from './saveDialog.vue';

export default {
  name: 'WbjhtjIndex',
  components: {
    WbjhSaveDialog,
    WbjhUpdateDialog,
    WbjhBatchUpdateDialog
  },
  data () {
    return {
      loading: false, // 页面是否loading状态

      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        xmmc: null, // 项目名称
        htyxqQ: null, // 计划开始时间起
        htyxqZ: null, // 计划开始时间止
        htyxQz: [null, null]
      },
      /* 查询条件 end */

      /* 表单校验规则 Start */
      filterParamsRules: {
        htyxQz: [this.$HMValidator.dateRange('开始时间')]
      },
      /* 表单校验规则 End */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 导出实际查询条件（避免查询条件的双向绑定导致点击导出按钮，获取到的数据与查询结果不一致） Start */
      exportFilterParams: {},
      /* 导出实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'jhmc', slotName: 'xmmc', label: '项目名称', align: 'left', minWidth: '160', type: 'text' },
        { key: 'htrq', slotName: 'htrq', label: '合同有效期', align: 'center', width: '200', type: 'date' },
        { key: 'jhzs', slotName: 'jhzs', label: '计划总数', align: 'right', minWidth: '80', type: 'text' },
        { key: 'wkss', slotName: 'wkss', label: '未开始数', align: 'right', minWidth: '80', type: 'text' },
        { key: 'zxz', slotName: 'zxz', label: '执行中', align: 'right', minWidth: '80', type: 'text' },
        { key: 'dscbg', slotName: 'dscbg', label: '待生成报告', align: 'right', minWidth: '80', type: 'text' },
        { key: 'ywc', slotName: 'ywc', label: '已完成', align: 'right', minWidth: '80', type: 'text' },
        { key: 'ygdzz', slotName: 'ygdzz', label: '已盖电子章', align: 'right', minWidth: '80', type: 'text' },
        { key: 'wcbfb', label: '完成百分比', align: 'left', minWidth: '80', type: 'text' }
      ],
      /* 表格列配置End */

      /* 弹窗 Start */
      showDialogName: '',
      dialogParams: {}
      /* 弹窗 End */

    };
  },

  methods: {
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name, _parmas) {
      this.showDialogName = _name;
      this.dialogParams = _parmas;
    },
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      [this.trueFilterParams.htyxqQ, this.trueFilterParams.htyxqZ] = this.trueFilterParams.htyxQz;
      this.search();
    },

    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */
      // 时间检验
      if (this.trueFilterParams.htyxqQ && this.trueFilterParams.htyxqZ && this.trueFilterParams.htyxqZ < this.trueFilterParams.htyxqQ) {
        this.$message({
          message: '合同有效期【开始时间起】不能晚于【开始时间止】',
          type: 'warning'
        });
        return;
      }
      this.loading = true;

      wbjhService.queryTj(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);

          // 导出条件更新为查询使用的条件
          this.exportFilterParams = JSON.parse(JSON.stringify(this.trueFilterParams));
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },

    /**
     * @description: 导出
     * @param {*}
     * @return {*}
     */
    handleExport () {
      this.loading = true;
      wbjhService.exportTj(this.exportFilterParams)
        .then(rsp => {
          const fileStream = rsp.data;
          const fileName = decodeURIComponent(escape(rsp.headers['content-disposition'].split('=')[1]));
          this.$HMUtil.downloadStreamFile(fileStream, fileName);
        })
        .catch(err => {
          console.error('导出错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created () {
    this.refreshSearch();
  },
  activated () {
    if (this.$route.params.isRefresh) {
      this.refreshSearch();
    }
  }
};
</script>
